import { render, staticRenderFns } from "./GroupTaxNumber.vue?vue&type=template&id=32421c11&"
import script from "./GroupTaxNumber.vue?vue&type=script&lang=js&"
export * from "./GroupTaxNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports